import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, User, Loader2, Sun } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { adminApi, getToken, setToken } from "./api";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (getToken()) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await adminApi.login(username.trim(), password);
      setToken(data.token);
      navigate("/admin");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3d38] via-[#0a4f47] to-[#062a26] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="px-8 pt-8 pb-6 text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg">
            <Sun className="w-7 h-7 text-white" />
          </div>
          <h1 className="mt-4 text-2xl font-extrabold text-slate-900">Zenova Admin</h1>
          <p className="text-sm text-slate-500 mt-1">Sign in to manage your website</p>
        </div>
        <form onSubmit={submit} className="px-8 pb-8 space-y-4">
          <div>
            <Label className="text-slate-700 text-sm font-semibold">Username</Label>
            <div className="relative mt-1.5">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="h-11 pl-10"
                required
              />
            </div>
          </div>
          <div>
            <Label className="text-slate-700 text-sm font-semibold">Password</Label>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••"
                className="h-11 pl-10"
                required
              />
            </div>
          </div>
          {err && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 px-3 py-2 rounded-md">
              {err}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0a4f47] hover:bg-[#0e6e63] text-white h-11 font-bold"
          >
            {loading ? (
              <span className="inline-flex items-center gap-2">
                <Loader2 className="w-4 h-4 animate-spin" /> Signing in...
              </span>
            ) : (
              "Sign In"
            )}
          </Button>
          <a
            href="/"
            className="block text-center text-sm text-slate-500 hover:text-[#0a4f47]"
          >
            ← Back to website
          </a>
        </form>
      </div>
    </div>
  );
}
